module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-text-sidebar-9c8756d0.svg";